// utils/historyUtils.js
/** tenta ler datas em dd/MM/yyyy ou ISO */
export function safeParseDate(input) {
    if (!input) return null;
  
    if (typeof input === "string" && input.includes("/")) {
      const [dd, mm, yyyy] = input.split("/").map((x) => parseInt(x, 10));
      if (!Number.isNaN(dd) && !Number.isNaN(mm) && !Number.isNaN(yyyy)) {
        return new Date(yyyy, mm - 1, dd);
      }
    }
  
    const d = new Date(input);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  
  export function monthKeyFromDate(dateObj) {
    if (!dateObj) return "Sem data";
    const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
    const yyyy = dateObj.getFullYear();
    return `${mm}/${yyyy}`;
  }
  
  export function normalizeText(s) {
    return String(s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "");
  }
  